import { render } from "./OptStatViewManagerData.vue?vue&type=template&id=1f91c6fe"
import script from "./OptStatViewManagerData.vue?vue&type=script&lang=js"
export * from "./OptStatViewManagerData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__